"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * Represents set of aggregated impact values for one row of sellout impact report detail row.
 * Designed to be used in both views - release and 4box.
 *
 * @author Jaroslav Sevcik
 * @author Jan Prokop
 */


var SelloutImpactReportDetailValuesDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutImpactReportDetailValuesDTO, _DomainObject_1$Domai);

  /**
   * Values without suffix are "real". That means computed from real transactions and sellout stock. The values marked as "impact"
   * are the core values of the report. It displays how the repricing really changed sales. Or at least how we believe it did according
   * to the forecast for the previous price.
   *
   * @param salesVolume The number of items sold. AKA real quantity. Retrieved from transactions.
   * @param salesVolumeSellout The forecasted sales volume for the new sellout price. AKA sellout quantity.
   * @param salesVolumeActual The forecasted sales volume for the old price. AKA actual quantity.
   * @param salesVolumeImpact The difference between {@link salesVolume} and {@link salesVolumeActual}. AKA real Δquantity.
   * @param salesVolumeImpactPercents The {@link salesVolumeImpact} as percents of the forecasted value. AKA real Δquantity %.
   * @param salesVolumeForecastDelta The difference between {@link salesVolumeSellout} and {@link salesVolumeActual}. AKA Δquantity.
   * @param salesVolumeForecastDeltaPercents The {@link salesVolumeForecastDelta} as percents of the old forecasted value.
   *        AKA Δquantity %.
   * @param salesVolumeFA The accuracy of forecast for sales volume. Computed as real sales volume - forecasted sales sales volume.
   *        AKA FA Δquantity.
   * @param salesVolumeFAPercents The {@link salesVolumeFA} as percents of the forecasted value. AKA FA Δquantity %.
   * @param revenue The money earned for selling the items. AKA real sales or real sales value. Retrieved from transactions (price without
   *        VAT).
   * @param revenueSellout The forecasted revenue for the new sellout price. AKA sellout sales.
   * @param revenueActual The forecasted revenue for the old price. AKA actual sales.
   * @param revenueImpact The difference between the real {@link revenue} and the one forecasted for the old price. AKA real Δsales.
   * @param revenueImpactPercents The {@link revenueImpact} as percents of the forecasted value. AKA real Δsales %.
   * @param revenueForecastDelta The difference between {@link revenueSellout} and {@link revenueActual}. AKA Δsales.
   * @param revenueForecastDeltaPercents The {@link revenueForecastDelta} as percents of the old forecasted value. AKA Δsales %.
   * @param revenueFA The accuracy of forecast for revenue. Computed as real revenue - forecasted revenue. AKA FA Δsales.
   * @param revenueFAPercents The {@link revenueFA} as percents of the forecasted value. AKA FA Δsales %.
   * @param profit The profit from selling the items. AKA BM1. Computed as revenue - cost price from transactions.
   * @param profitSellout The forecasted profit for the new sellout price. AKA sellout BM1.
   * @param profitActual The forecasted profit for the old price. AKA actual BM1.
   * @param profitImpact The difference between the real {@link profit} and the one forecasted for the old price. AKA real ΔBM1.
   * @param profitImpactPercents The {@link profitImpact} as percents of the forecasted value. AKA real ΔBM1 %.
   * @param profitForecastDelta The difference between {@link profitSellout} and {@link profitActual}. AKA ΔBM1.
   * @param profitForecastDeltaPercents The {@link profitForecastDelta} as percents of the old forecasted value. AKA ΔBM1 %.
   * @param profitFA The accuracy of forecast for profit. Computed as real profit - forecasted profit. AKA FA ΔBM1.
   * @param profitFAPercents The {@link profitFA} as percents of the forecasted value. AKA FA ΔBM1 %.
   * @param margin The margin of items sold. AKA BM2. Computed as revenue - (cost price from transactions - vendor allowance).
   * @param marginSellout The forecasted margin for the new sellout price. AKA sellout BM2.
   * @param marginActual The forecasted margin for the old price. AKA actual BM2.
   * @param marginImpact The difference between the real {@link margin} and the one forecasted for the old price. AKA real ΔBM2.
   * @param marginImpactPercents The {@link marginImpact} as percents of the forecasted value. AKA real ΔBM2 %.
   * @param marginForecastDelta The difference between {@link marginSellout} and {@link marginActual}. AKA ΔBM2.
   * @param marginForecastDeltaPercents The {@link marginForecastDelta} as percents of the old forecasted value.  AKA ΔBM2 %.
   * @param marginFA The accuracy of forecast for margin. Computed as real margin - forecasted margin. AKA FA ΔBM2.
   * @param marginFAPercents The {@link marginFA} as percents of the forecasted value. AKA FA ΔBM2 %.
   * @param initialStockVolume The sellout stock volume at the beginning of the selected interval or of the price validity, if it is
   *        later.
   * @param stockVolume The sellout stock volume at the end of the selected interval or of the price validity, if it is later.
   * @param stockVolumeDelta The volume of sellout stock sold in the selected interval.
   *        Computed as {@link initialStockVolume} - {@link stockVolume}.
   * @param stockVolumeDeltaPercents The {@link stockVolumeDelta} as percents of the initial value.
   * @param initialStockValue The sellout stock value at the beginning of the selected interval or of the price validity, if it is later.
   * @param stockValue The sellout stock value at the end of the selected interval or of the price validity, if it is later.
   *        Computed as {@link stockVolume} * purchase price.
   * @param stockValueDelta The value of sellout stock sold in the selected interval.
   *        Computed as {@link initialStockValue} - {@link stockValue}.
   * @param stockValueDeltaPercents The {@link stockValueDelta} as percents of the initial value.
   * @param faPercents The accuracy of forecast in percents.
   * @param realDays The number of days for which the values are calculated. It is the intersection of user selected interval
   *        and the price validity.
   */
  function SelloutImpactReportDetailValuesDTO(salesVolume, salesVolumeSellout, salesVolumeActual, salesVolumeImpact, salesVolumeImpactPercents, salesVolumeForecastDelta, salesVolumeForecastDeltaPercents, salesVolumeFA, salesVolumeFAPercents, revenue, revenueSellout, revenueActual, revenueImpact, revenueImpactPercents, revenueForecastDelta, revenueForecastDeltaPercents, revenueFA, revenueFAPercents, profit, profitSellout, profitActual, profitImpact, profitImpactPercents, profitForecastDelta, profitForecastDeltaPercents, profitFA, profitFAPercents, margin, marginSellout, marginActual, marginImpact, marginImpactPercents, marginForecastDelta, marginForecastDeltaPercents, marginFA, marginFAPercents, initialStockVolume, stockVolume, stockVolumeDelta, stockVolumeDeltaPercents, initialStockValue, stockValue, stockValueDelta, stockValueDeltaPercents, faPercents, realDays) {
    var _this;

    _classCallCheck(this, SelloutImpactReportDetailValuesDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutImpactReportDetailValuesDTO).call(this));
    _this.salesVolume = salesVolume;
    _this.salesVolumeSellout = salesVolumeSellout;
    _this.salesVolumeActual = salesVolumeActual;
    _this.salesVolumeImpact = salesVolumeImpact;
    _this.salesVolumeImpactPercents = salesVolumeImpactPercents;
    _this.salesVolumeForecastDelta = salesVolumeForecastDelta;
    _this.salesVolumeForecastDeltaPercents = salesVolumeForecastDeltaPercents;
    _this.salesVolumeFA = salesVolumeFA;
    _this.salesVolumeFAPercents = salesVolumeFAPercents;
    _this.revenue = revenue;
    _this.revenueSellout = revenueSellout;
    _this.revenueActual = revenueActual;
    _this.revenueImpact = revenueImpact;
    _this.revenueImpactPercents = revenueImpactPercents;
    _this.revenueForecastDelta = revenueForecastDelta;
    _this.revenueForecastDeltaPercents = revenueForecastDeltaPercents;
    _this.revenueFA = revenueFA;
    _this.revenueFAPercents = revenueFAPercents;
    _this.profit = profit;
    _this.profitSellout = profitSellout;
    _this.profitActual = profitActual;
    _this.profitImpact = profitImpact;
    _this.profitImpactPercents = profitImpactPercents;
    _this.profitForecastDelta = profitForecastDelta;
    _this.profitForecastDeltaPercents = profitForecastDeltaPercents;
    _this.profitFA = profitFA;
    _this.profitFAPercents = profitFAPercents;
    _this.margin = margin;
    _this.marginSellout = marginSellout;
    _this.marginActual = marginActual;
    _this.marginImpact = marginImpact;
    _this.marginImpactPercents = marginImpactPercents;
    _this.marginForecastDelta = marginForecastDelta;
    _this.marginForecastDeltaPercents = marginForecastDeltaPercents;
    _this.marginFA = marginFA;
    _this.marginFAPercents = marginFAPercents;
    _this.initialStockVolume = initialStockVolume;
    _this.stockVolume = stockVolume;
    _this.stockVolumeDelta = stockVolumeDelta;
    _this.stockVolumeDeltaPercents = stockVolumeDeltaPercents;
    _this.initialStockValue = initialStockValue;
    _this.stockValue = stockValue;
    _this.stockValueDelta = stockValueDelta;
    _this.stockValueDeltaPercents = stockValueDeltaPercents;
    _this.faPercents = faPercents;
    _this.realDays = realDays;
    return _this;
  }

  return SelloutImpactReportDetailValuesDTO;
}(DomainObject_1.DomainObject);

exports.SelloutImpactReportDetailValuesDTO = SelloutImpactReportDetailValuesDTO;

SelloutImpactReportDetailValuesDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutImpactReportDetailValuesDTO.name);
  return {
    salesVolume: builder.bigNum('salesVolume'),
    salesVolumeSellout: builder.opt(builder.bigNum('salesVolumeSellout')),
    salesVolumeActual: builder.opt(builder.bigNum('salesVolumeActual')),
    salesVolumeImpact: builder.opt(builder.bigNum('salesVolumeImpact')),
    salesVolumeImpactPercents: builder.opt(builder.bigNum('salesVolumeImpactPercents')),
    salesVolumeForecastDelta: builder.opt(builder.bigNum('salesVolumeForecastDelta')),
    salesVolumeForecastDeltaPercents: builder.opt(builder.bigNum('salesVolumeForecastDeltaPercents')),
    salesVolumeFA: builder.opt(builder.bigNum('salesVolumeFA')),
    salesVolumeFAPercents: builder.opt(builder.bigNum('salesVolumeFAPercents')),
    revenue: builder.bigNum('revenue'),
    revenueSellout: builder.opt(builder.bigNum('revenueSellout')),
    revenueActual: builder.opt(builder.bigNum('revenueActual')),
    revenueImpact: builder.opt(builder.bigNum('revenueImpact')),
    revenueImpactPercents: builder.opt(builder.bigNum('revenueImpactPercents')),
    revenueForecastDelta: builder.opt(builder.bigNum('revenueForecastDelta')),
    revenueForecastDeltaPercents: builder.opt(builder.bigNum('revenueForecastDeltaPercents')),
    revenueFA: builder.opt(builder.bigNum('revenueFA')),
    revenueFAPercents: builder.opt(builder.bigNum('revenueFAPercents')),
    profit: builder.bigNum('profit'),
    profitSellout: builder.opt(builder.bigNum('profitSellout')),
    profitActual: builder.opt(builder.bigNum('profitActual')),
    profitImpact: builder.opt(builder.bigNum('profitImpact')),
    profitImpactPercents: builder.opt(builder.bigNum('profitImpactPercents')),
    profitForecastDelta: builder.opt(builder.bigNum('profitForecastDelta')),
    profitForecastDeltaPercents: builder.opt(builder.bigNum('profitForecastDeltaPercents')),
    profitFA: builder.opt(builder.bigNum('profitFA')),
    profitFAPercents: builder.opt(builder.bigNum('profitFAPercents')),
    margin: builder.bigNum('margin'),
    marginSellout: builder.opt(builder.bigNum('marginSellout')),
    marginActual: builder.opt(builder.bigNum('marginActual')),
    marginImpact: builder.opt(builder.bigNum('marginImpact')),
    marginImpactPercents: builder.opt(builder.bigNum('marginImpactPercents')),
    marginForecastDelta: builder.opt(builder.bigNum('marginForecastDelta')),
    marginForecastDeltaPercents: builder.opt(builder.bigNum('marginForecastDeltaPercents')),
    marginFA: builder.opt(builder.bigNum('marginFA')),
    marginFAPercents: builder.opt(builder.bigNum('marginFAPercents')),
    initialStockVolume: builder.opt(builder.bigNum('initialStockVolume')),
    stockVolume: builder.opt(builder.bigNum('stockVolume')),
    stockVolumeDelta: builder.opt(builder.bigNum('stockVolumeDelta')),
    stockVolumeDeltaPercents: builder.opt(builder.bigNum('stockVolumeDeltaPercents')),
    initialStockValue: builder.opt(builder.bigNum('initialStockValue')),
    stockValue: builder.opt(builder.bigNum('stockValue')),
    stockValueDelta: builder.opt(builder.bigNum('stockValueDelta')),
    stockValueDeltaPercents: builder.opt(builder.bigNum('stockValueDeltaPercents')),
    faPercents: builder.opt(builder.bigNum('faPercents')),
    realDays: builder.num('realDays')
  };
}();